import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { LoginParams } from '@m4u-angular/base/entities/BaseEntities';
import { Observable, of } from 'rxjs';
import { Utils } from '../helpers/Utils';
import { LoginService } from './login.service';
import { NavigatorService } from './navigator.service';
import { SessionService } from './session.service';
import { EnumLoginSecureKeyTypes } from './sysenums.enum';
import { SysGlobals } from './sysglobals';

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(
        private sessionService: SessionService,
        private navigator: NavigatorService,
        private loginService: LoginService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this.sessionService.IsLoggedIn) return of(true);

        const [returnUrl, returnUrlParams] = this.getReturnUrlWithParams(route, state);

        const currentSessionID = this.sessionService.GetSessionID();
        const paramsSessionID = this.navigator.GetQueryParams(this.navigator.IsCurrentRouteWindow()).SessionID;
        const returnUrlParamsSessionID = returnUrlParams?.SessionID;
        const sessionID = paramsSessionID || returnUrlParamsSessionID || currentSessionID;
        if (!Utils.IsEmpty(sessionID)) {
            const loginParams = new LoginParams;
            loginParams.SecureKey = sessionID;
            loginParams.SecureKeyType = EnumLoginSecureKeyTypes.Session;
            return this.loginService.DoLogin(loginParams, !!currentSessionID, !currentSessionID, () => {}, () => this.goToLoginPage(returnUrl, returnUrlParams));
        }

        this.goToLoginPage(returnUrl, returnUrlParams);
        return of(false);
    }

    private getReturnUrlWithParams(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): [string, any] {
        // Get clean route without params
        const paramsStartIndex = state.url.indexOf('?');
        const cleanUrl = paramsStartIndex >= 0 ? state.url.slice(0, paramsStartIndex) : state.url;

        // Get route without window part
        let urlSegments = cleanUrl.replace(/^\/|\/$|\(|\)/g, '').split('/');
        const windowIndex = urlSegments.findIndex(x => x.startsWith('window'));
        urlSegments = urlSegments.slice(0, windowIndex >= 0 ? windowIndex : undefined);

        // Get route url string
        const url = urlSegments.join('/');
        const params = this.navigator.IsCurrentRouteWindow() ? {} : this.navigator.GetQueryParamsWithoutPrefixes(route.queryParams, false);

        return [url, params];
    }

    private goToLoginPage(returnUrl: string, returnUrlParams: any) {
        this.navigator.Navigate(['/system/login'], { Language: SysGlobals.Language, ReturnUrl: returnUrl, ReturnUrlParams: JSON.stringify(returnUrlParams) });
    }
}
